import PixverseEffectsSettings from "./api-settings/PixverseEffectsSettings";
import PixverseTransitionSettings from "./api-settings/PixverseTransitionSettings";
import PixverseImageToVideoSettings from "./api-settings/PixverseImageToVideoSettings";
import FluxProKontextSettings from "./api-settings/FluxProKontextSettings";
import FluxPuLIDSettings from "./api-settings/FluxPuLIDSettings";
import ImageEditingSettings from "./api-settings/ImageEditingSettings";
import FalAiViduSettings from "./api-settings/FalAiViduSettings";

export const APISettingsPanel = (props) => {
  const { selectedAPI } = props;
  if (!selectedAPI) {
    return (
      <div className="text-center text-gray-400 py-8">
        <p>Select an AI service to view its settings</p>
      </div>
    );
  }

  const renderSettings = () => {
    switch (selectedAPI.id) {
      case "pixverse-effects":
        return <PixverseEffectsSettings {...props} />;
      case "pixverse-transition":
        return <PixverseTransitionSettings {...props} />;
      case "pixverse-image-to-video":
        return <PixverseImageToVideoSettings {...props} />;
      case "flux-pro-kontext":
        return <FluxProKontextSettings {...props} />;
      case "nano-banana":
        return <FluxPuLIDSettings {...props} />;
      case "image-editing":
        return <ImageEditingSettings {...props} />;
      case "fal-ai-vidu":
        return <FalAiViduSettings {...props} />;
      default:
        return (
          <div className="text-center text-gray-400 py-8">
            <p>Settings for this API are not configured yet</p>
          </div>
        );
    }
  };

  return (
    <div
      className="overflow-y-auto"
      style={{
        height: "calc(100% - 28px)", // Adjust height to fit within the parent container
      }}
    >
      {renderSettings()}
    </div>
  );
};
export default APISettingsPanel;
